<template>
  <el-input
    class="el-number-input"
    type="number"
    :value="value"
    :placeholder="thePlaceholder"
    :clearable="clearable"
    :disabled="disabled"
    :prefix-icon="prefixIcon"
    :suffix-icon="suffixIcon"
    :name="name"
    :readonly="readonly"
    :step="step"
    :autofocus="autofocus"
    :form="form"
    :label="label"
    :tabindex="tabindex"
    :validate-event="validateEvent"
    @input="input"
    @change="change"
    @mousewheel.native.prevent
    @keydown.up.native.prevent
    @keydown.down.native.prevent
    @keydown.e.native.prevent
    @keydown.187.native.prevent
    @keydown.107.native.prevent
    @keydown.189.native="e=>!(min<0)&&e.preventDefault()"
    @keydown.109.native="e=>!(min<0)&&e.preventDefault()"
    @keydown.190.native="e=>numberType=='int'&&e.preventDefault()"
    @keydown.110.native="e=>numberType=='int'&&e.preventDefault()"
  ></el-input>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    numberType: {
      default: "int",
    },
    min: {
      default: 1,
    },
    value: {
      required: true,
    },
    max: {
      required: false,
      type: Number,
      default: Infinity,
    }, //原生属性，最大输入长度	number	—	—
    min: {
      required: false,
      type: Number,
      default: 0,
    }, //	原生属性，最小输入长度	number	—	—
    placeholder: {
      required: false,
      type: String,
      default: "",
    }, //	输入框占位文本	string	—	—
    clearable: {
      required: false,
      type: Boolean,
      default: true,
    }, //	是否可清空	boolean	—	false
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    }, //	禁用	boolean	—	false
    prefixIcon: {
      required: false,
      type: String,
      default: "",
    }, //	输入框头部图标	string	—	—
    suffixIcon: {
      required: false,
      type: String,
      default: "",
    }, //	输入框尾部图标	string	—	—
    name: {
      required: false,
      type: String,
      default: "",
    }, //	原生属性	string	—	—
    readonly: {
      required: false,
      type: Boolean,
      default: false,
    }, //	原生属性，是否只读	boolean	—	false
    step: {
      required: false,
    }, //	原生属性，设置输入字段的合法数字间隔	—	—	—
    autofocus: {
      required: false,
      type: Boolean,
      default: false,
    }, //	原生属性，自动获取焦点	boolean	true, false	false
    form: {
      required: false,
      type: String,
      default: "",
    }, //	原生属性	string	—	—
    label: {
      required: false,
      type: String,
      default: "",
    }, //	输入框关联的label文字	string	—	—
    tabindex: {
      required: false,
      type: String,
      default: "",
    }, //	输入框的tabindex	string	-	-
    validateEvent: {
      required: false,
      type: Boolean,
      default: true,
    }, //	输入时是否触发表单的校验	boolean	-	true
  },
  data() {
    return {};
  },
  computed: {
    thePlaceholder() {
      if (this.placeholder) {
        return this.placeholder;
      } else {
        return `输入区间 ( ${this.min} - ${this.max} )`;
      }
    },
  },
  methods: {
    input(value) {
      if (value > this.max) {
        this.$emit("input", this.max);
      } else {
        this.$emit("input", value);
      }
    },
    change(value) {
      if (value < this.min || value === "") {
        this.$emit("input", this.min);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-number-input {
  /deep/input::placeholder {
    opacity: 0.5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/element-secondary/el-number-input/index.vue